export { ExchangeAlt1 } from "./ExchangeAlt1";
